import { ChevronDown, Download, Upload } from 'lucide-react'

import { HeaderActions, HeaderBar } from '@fortem-monorepo/react-spa'
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@fortem-monorepo/react-ui'

import { CanAccess } from '@/components/CanAccess'
import { LayoutOutlet } from '@/components/LayoutOutlet'
import { NavigationTabs, NavigationTabsList } from '@/components/NavigationTabs'
import { TRADING_LINKS } from '@/constants/links'
import { PERMISSIONS } from '@/constants/permissions'
import { TradeActionsProvider } from '@/pages/trading/trade-actions'

export interface TradingLayoutProps {}

export const TradingLayout: React.FC<TradingLayoutProps> = ({}) => {
  return (
    <TradeActionsProvider>
      {(ctx) => {
        return (
          <>
            <HeaderBar>
              <NavigationTabs>
                <NavigationTabsList links={TRADING_LINKS} />
              </NavigationTabs>
            </HeaderBar>
            <CanAccess permissions={[PERMISSIONS.WRITE_TRADES]}>
              <HeaderActions>
                <DropdownMenu>
                  <DropdownMenuTrigger>
                    <Button size="sm">
                      Upload trades <ChevronDown />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem className={'justify-between'} onClick={() => ctx.uploadTrades()}>
                      From file <Upload />
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => ctx.downloadTemplate()}>
                      Download Template
                      <Download />
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </HeaderActions>
            </CanAccess>
            <LayoutOutlet />
          </>
        )
      }}
    </TradeActionsProvider>
  )
}

export default TradingLayout
